import { render, staticRenderFns } from "./SatisfactionFormAnswersList.vue?vue&type=template&id=0fedacf1"
import script from "./SatisfactionFormAnswersList.vue?vue&type=script&lang=js"
export * from "./SatisfactionFormAnswersList.vue?vue&type=script&lang=js"
import style0 from "./SatisfactionFormAnswersList.vue?vue&type=style&index=0&id=0fedacf1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports